module.exports = __webpack_public_path__ + "img/specific.1e31da17.svg";